<template>
  <footer class="bg-[#11111b] text-white fixed bottom-0 w-full z-40">
    <div class="container px-4 py-2">
      <div class="text-sm text-white/50">
        © June-2025 Borenn Morm - Version {{ version }}
      </div>
    </div>
  </footer>
</template>

<script setup>
defineProps({
  version: {
    type: String,
    default: "0.1.0",
  },
});
</script>
